const setPrivacyCheck = () => {
  const privacyCheck = document.querySelector('.js-privacy-check');
  const submitBtn = document.querySelector('.js-submit-btn');

  function judgePrivacyCheck() {
    if(privacyCheck?.checked) {
      if(submitBtn) {
        submitBtn.disabled = false;
      }
    } else {
      if(submitBtn) {
        submitBtn.disabled = true;
      }
    }
  }

  privacyCheck?.addEventListener('change', judgePrivacyCheck)
  judgePrivacyCheck();
}

export default setPrivacyCheck;